<ng-container *ngIf="!showTechnicalIssuesBanner; else technicalIssuesBanner">
    <ng-container *ngIf="isAuthenticated;else loaderBlock">
        <app-header [filterRequest]="filters">
        </app-header>
        <div class="alert-container" *ngIf="alerts != undefined && alerts.length > 0">
            <app-alert class="alert" *ngFor="let a of alerts" [id]="a.id" [message]="a.message"></app-alert>
        </div>
        <app-navbar></app-navbar>
        <div id="warning-banner-user-unauthorised" *ngIf="!isUserAuthorized">
            <app-warning-banner [message]="warningMessage"></app-warning-banner>
        </div>
    </ng-container>
    
    <ng-template #loaderBlock>
        <div class="loader-block">
            <loader size="large"></loader>
        </div>
    </ng-template>

    <router-outlet></router-outlet>
    
    <app-footer *ngIf="isAuthenticated"></app-footer>
</ng-container>
<ng-template #technicalIssuesBanner>
    <div id="technical-issues-banner">
        <app-warning-banner [message]="technicalIssuesMessage" [showCloseButton]="false"></app-warning-banner>
    </div>
</ng-template>